import { unstable_useIsFocusVisible as useIsFocusVisible } from '@material-ui/utils';
export default useIsFocusVisible;